import React from 'react';
import { FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { i18n } from '../contentByLabelMacroI18n.ts';

const styles = cssMap({
	container: {
		minHeight: 'auto',
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
		paddingBlock: token('space.150'),
		paddingInline: token('space.150'),
	},
	heading: {
		color: token('color.text.subtlest'),
		font: token('font.body'),
		fontWeight: token('font.weight.regular'),
	},
	message: {
		color: token('color.text.subtlest'),
	},
});

interface EmptyStateProps {
	title?: string;
	showEditCTA: boolean;
}

export const EmptyState = ({ title, showEditCTA }: EmptyStateProps): React.JSX.Element => {
	return (
		<Box xcss={styles.container} testId="content-by-label-empty-state">
			<Stack space="space.100">
				<Box xcss={styles.heading} as="h5">
					{title || <FormattedMessage {...i18n.emptyTitle} />}
				</Box>
				<Box xcss={styles.message} as="p">
					<FormattedMessage {...(showEditCTA ? i18n.emptyContentInEditor : i18n.emptyContent)} />
				</Box>
			</Stack>
		</Box>
	);
};
